import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const ActionList = styled.ul.withConfig({ componentId: 'sc-1ymvxjr-0' })`
    --_padding: ${size(1.5)};

    list-style: none;
    padding: 0;
    margin: calc(var(--_padding) * -1) 0;
`;

export const ActionListItem = styled.li.withConfig({ componentId: 'sc-1ymvxjr-1' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--_padding);
    padding: var(--_padding) 0;

    & + & {
        border-top: 1px solid var(--c-border-main);
    }
`;
